module.exports = __webpack_public_path__ + "media/images/mobile/solutions/8-2da2f71097f4637cbfbe5b00ce62495f.png";